import { render, staticRenderFns } from "./ProjectSetupPage.vue?vue&type=template&id=033f2684&scoped=true"
import script from "./ProjectSetupPage.vue?vue&type=script&lang=js"
export * from "./ProjectSetupPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectSetupPage.vue?vue&type=style&index=0&id=033f2684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033f2684",
  null
  
)

export default component.exports